import React from 'react';
import PropTypes from 'prop-types';

import styles from '../collegeProspectTab.scss';

const ProspectSectionRow = ({ label, value, testIdPrefix, testId }) => (
    <div className={styles.academicsRow} data-testid={`${testIdPrefix}.${testId}`}>
        <span
            className={styles.academicsRowLabel}
            data-testid={`${testIdPrefix}.${testId}.label`}
        >
            {label}
        </span>
        <span
            className={styles.academicsRowValue}
            data-testid={`${testIdPrefix}.${testId}.value`}
        >
            {value || ''}
        </span>
    </div>
);

ProspectSectionRow.propTypes = {
    label: PropTypes.node.isRequired,
    value: PropTypes.node,
    testIdPrefix: PropTypes.string.isRequired,
    testId: PropTypes.string.isRequired,
};

ProspectSectionRow.defaultProps = {
    value: '',
};

export default ProspectSectionRow;
